<template>
  <div id="home">
    <navigation />
    <!-- Loader -->
    <loading :show="show" :label="label">:overlay="overlay"></loading>
    <!-- Loader -->
    <mdb-container class="py-3 mx-auto">
      <div class="row my-3">
        <div class="col-md-12">
          <h1>Personal Video Dashboard</h1>
          <p>The Death Star plans are not in the main computer. Where are those transmissions you intercepted? What have you done with those plans? We intercepted no transmissions. Aaah....This is a consular ship. Were on a diplomatic mission. If this is a consular ship...were is the Ambassador? Commander, tear this ship apart until you've found those plans and bring me the Ambassador. I want her alive! There she is! Set for stun! She'll be all right. Inform Lord Vader we have a prisoner.</p>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-8">
          <h2>Upload new video</h2>
          <p>Orbiting the planet at maximum velocity. The moon with the Rebel base will be in range in thirty minutes. This will be a day long remembered. It has seen the end of Kenobi and it will soon see the end of the Rebellion.</p>
          <!-- Image Upload Div -->
          <div id="video-upload">
            <form id="video-form">
              <span class="upload-label">Video Upload:</span>
              <input type="file" id="file" ref="videoFile" />
              <mdb-input label="Video title" id="title" v-model="title" />
              <mdb-input
                label="Video description"
                outline
                type="textarea"
                rows="5"
                id="description"
                v-model="description"
              />
              <select id="select-category" class="browser-default custom-select" v-model="select" placeholder="edit me">
                <option selected value="" >Select a Category</option>
                <option value="AI1">Introduction to Artificial Intelligence</option>
                <option value="CA">Cloud Architekturen</option>
                <option value="FPK">Fortgeschrittene Programmierkonzepte</option>
                <option value="IOT">Internet of things</option>
                <option value="IT(de)">IT Systems (de)</option>
                <option value="IT(en)">IT Systems (en)</option>
                <option value="KS">Kognitive Systeme</option>
              </select>

              <div class="text-center py-4 mt-3">
                <mdb-btn
                  color="#f9a825 yellow darken-3"
                  icon="fas fa-cloud-upload-alt"
                  v-on:click="submit()"
                  type="button"
                >Upload Video</mdb-btn>
              </div>
            </form>
          </div>
          <!-- / Image Upload Div -->
        </div>
        <div class="col-md-4">
          <h2>Your Videos</h2>
          <div class="video-list-box">
            <!-- List of Videos -->
            <mdb-list-group>
              <mdb-list-group-item v-for="(video, i) in data" :key="i" class="mb-3">
                <a v-on:click="gotovideo(video.VideoId)">
                  <div v-if="video.VideoThumbnailUri" class="img-wrapper">
                    <img
                      v-bind:src="video.VideoThumbnailUri"
                      class="rounded thumbnail-img"
                      alt="..."
                    />
                  </div>
                  <div v-else class="img-wrapper">
                    <img src="../assets/filler.jpg" class="rounded thumbnail-img" alt="..." />
                  </div>
                  <div class="description-box">
                    <span class="video-title">{{video.VideoTitel}}</span>
                    <!-- <p class="video-description">{{video.VideoDescription}}</p> -->
                  </div>
                </a>
              </mdb-list-group-item>
            </mdb-list-group>
            <!-- / List of Videos -->
          </div>
        </div>
      </div>
    </mdb-container>
  </div>
</template>

<script>
import {
  mdbContainer,
  mdbBtn,
  mdbListGroup,
  mdbListGroupItem,
  mdbInput
} from "mdbvue";
import navigation from "@/components/navigation";
import loading from "vue-full-loading";
import { v4 as uuidv4 } from "uuid";

export default {
  name: "Home",
  components: {
    mdbContainer,
    navigation,
    mdbBtn,
    mdbListGroup,
    mdbListGroupItem,
    mdbInput,
    loading
  },
  data() {
    return {
      data: null,
      show: false,
      label: "Loading...",
      blobServiceClient: "",
      reader: "",
      bytes: "",
    };
  },
  beforeCreate: function() {
    if (!this.$session.exists()) {
      this.$router.replace({ name: "login" });
    }
  },
  created() {
    this.getVideos();
    this.setSelect();
  },
  methods: {
    /** Get Videos */ 
    async getVideos() {
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json"
        }
      };
      const res = await fetch(
        "https://thitch.azurewebsites.net/api/GetVideosByUser?UserId=" +
          this.$session.get("UserId"),
        requestOptions
      );
      const data = await res.json();
       // for loop to check if thumbnails exist (hack)
      data.forEach(video => {

        // Check if image exists
        var http = new XMLHttpRequest();
        http.open('HEAD', video.VideoThumbnailUri, false);
        http.send();

        if(http.status == 404) {
          video.VideoThumbnailUri = "https://thitchstorage.blob.core.windows.net/thitchimage/Thitch_filler.jpg";
        }

      });

      this.data = data;

      console.log("res ", this.data);
    },
    /** Link to Video */
    gotovideo: function(value) {
      this.$router.push({ path: `/video/${value}` });
    },
    setSelect() {
      this.select = "";
    },
    /** Video Upload Submit */
    submit() {

      // Blob SAS Token holen
      this.createBlob();

      const uuid = uuidv4();
      const blobNamePng = uuid + ".png";
      const blobNameVideo = uuid + ".mp4";
      const containerClient = this.data.blobServiceClient.getContainerClient("thitchblob");
      const blockBlobClient = containerClient.getBlockBlobClient(blobNameVideo);

      this.show = true;

      // start async
      return blockBlobClient
        .uploadBrowserData(this.$refs.videoFile.files[0], {
          blobHTTPHeaders: { blobContentType: "video/mp4" }
        })
        .then(uploadBlobResponse => {        
          console.log(`Upload block blob ${blobNameVideo} successfully`,uploadBlobResponse.requestId);

          event.preventDefault();

          const formData = new FormData();
          formData.append("VideoPath","https://thitchstorage.blob.core.windows.net/thitchblob/" +blobNameVideo);
          formData.append("ThumbnailFile","https://thitchstorage.blob.core.windows.net/thitchimage/" +blobNamePng);
          formData.append("userId", this.$session.get("UserId"));
          formData.append("title", this.title);
          formData.append("description", this.description);
          formData.append("category", this.select);
          const requestOptions = {
            method: "POST",
            body: formData
          };
          fetch(
            //"http://localhost:7071/api/UploadVideo",
            "https://thitch.azurewebsites.net/api/UploadVideo?code=iuLa3SR7K38rcv18gkyxpl/ojcEkovql8WaUlyWUluUnud8oFdL7CA==",
            requestOptions
          )
            .then(async response => {
              if (response.ok) {
                console.log('Upload to Databes was successfully');
                this.show = false;
                location.reload();
              }
            })
            .catch(error => {
              console.log("Error", error);
            });
        });
    },
    /** Create Blob */ 
    createBlob() {
      const { BlobServiceClient } = require("@azure/storage-blob");
      const account = "thitchstorage";
      const sas = "sv=2020-02-10&ss=bfqt&srt=sco&sp=rwdlacuptfx&se=2029-07-03T22:00:00Z&st=2021-07-03T22:00:00Z&spr=https&sig=cAjQEwmRnRI0qv8lKB9W2NaDSvNOOHs9KsSusLbJQDQ%3D";

      this.data.blobServiceClient = new BlobServiceClient(`https://${account}.blob.core.windows.net?${sas}`);
    }
  }
};
</script>

<style scoped>
#home {
  background-color: #ffffff;
  border: 1px solid #cccccc;
}
#dropzone {
  width: 100%;
  height: 200;
  margin: 0 auto;
  display: block;
}
.backg {
  background-color: #ff8863;
}
.buttonbackg {
  background-color: #d65db1;
  color: white;
}
.video-description {
  max-height: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
}
#video-upload {
  text-align: center;
  width: 350px;
  border-radius: 0.125rem;
}
#file {
  display: block;
}
#video-upload input {
  margin-top: 25px;
}
.video-title {
  font-size: 1.5rem;
  font-weight: 400;
}
.description-box {
  padding: 0 10px;
}
.video-list-box {
  height: 800px;
  overflow: scroll;
}
.list-group-item {
  box-shadow: 6px 10px 22px -14px rgba(0, 0, 0, 0.75);
  max-width: 320px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
}
.list-group-item:hover {
  box-shadow: 10px 10px 12px 0px rgba(179, 157, 219, 1);
}
.thumbnail-img {
  width: 100%;
}
.upload-label {
  float: left;
  font-size: 1rem;
  margin-bottom: 5px;
  font-weight: 400;
  margin-top: 15px;
}
.img-wrapper {
  max-height: 156px;
  overflow: hidden;
  border-radius: 4px;
}
</style>